import { useCallback, useSyncExternalStore } from 'react'

// Брейкпоинт, видимый из JS. Нужен там, где CSS-варианта недостаточно: размеры,
// которые компонент считает сам (геометрия Ганта), и ветвление поведения.
// Вёрстку так не разводим — для неё есть обычные `sm:`/`md:`.
export function useMediaQuery(query: string): boolean {
  const subscribe = useCallback(
    (onChange: () => void) => {
      const mql = window.matchMedia(query)
      mql.addEventListener('change', onChange)
      return () => mql.removeEventListener('change', onChange)
    },
    [query],
  )

  return useSyncExternalStore(
    subscribe,
    () => window.matchMedia(query).matches,
    // Значение до гидратации: считаем экран широким, чтобы десктоп не мигал.
    () => false,
  )
}
